/**
 * Gestisce la dimensione massima di un allegato leggendola da una variabile d'ambiente,
 * in modo che sia comunque sempre impostata.
 */
export const MAX_ATTACHMENT_SIZE = process.env.MAX_ATTACHMENT_SIZE
  ? Number(process.env.MAX_ATTACHMENT_SIZE)
  : 100; // 100MB
